import React from "react";
import { Box, ButtonBase, Skeleton, Typography } from "@mui/material";
import TeamLogo from "../TeamLogo";
import { homeCardHover, horizontalScroll } from "../home/homeStyles";
import { colors } from "../../theme";
import { splitFranchiseDisplayName } from "../../utils/splitFranchiseDisplayName";

const TILE_WIDTH = 100;
const TILE_SKELETON_HEIGHT = 112;

const labelLineSx = {
  width: "100%",
  minWidth: 0,
  display: "block",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const TeamLogoRail = ({ teams = [], loading = false, onSelect }) => {
  if (loading && teams.length === 0) {
    return (
      <Box sx={{ ...horizontalScroll, p: 2 }}>
        {[1, 2, 3, 4, 5, 6].map((key) => (
          <Skeleton
            key={key}
            variant="rounded"
            width={TILE_WIDTH}
            height={TILE_SKELETON_HEIGHT}
            sx={{ flexShrink: 0 }}
          />
        ))}
      </Box>
    );
  }

  return (
    <Box sx={{ ...horizontalScroll, p: 2 }}>
      {teams.map((team) => {
        const { city, nickname } = splitFranchiseDisplayName(team.name);
        return (
          <ButtonBase
            key={team.id || team.mlbId || team.name}
            onClick={() => onSelect?.(team.id || team.name)}
            aria-label={team.name}
            title={team.name}
            sx={{
              minWidth: TILE_WIDTH,
              width: TILE_WIDTH,
              maxWidth: TILE_WIDTH,
              flex: "0 0 auto",
              overflow: "hidden",
              boxSizing: "border-box",
              py: 1,
              px: 0.75,
              borderRadius: 1.5,
              border: `1px solid ${colors.border}`,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 0.75,
              ...homeCardHover,
            }}
          >
            <TeamLogo
              sport={team.sport || "mlb"}
              teamName={team.name}
              mlbTeamId={team.mlbId}
              franchiseId={team.id}
              size={40}
            />
            <Box sx={{ width: "100%", minWidth: 0, textAlign: "center" }}>
              {city ? (
                <Typography
                  variant="caption"
                  color="text.secondary"
                  title={team.name}
                  sx={labelLineSx}
                >
                  {city}
                </Typography>
              ) : null}
              <Typography
                variant="caption"
                fontWeight={600}
                title={team.name}
                sx={labelLineSx}
              >
                {nickname || team.name}
              </Typography>
            </Box>
          </ButtonBase>
        );
      })}
    </Box>
  );
};

export default TeamLogoRail;
